var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Comlink from "comlink";
import { getCompleteSessionData } from "src/utils/session-storage";
export let dashboardWorkerRef;
export const initDashboardApiWorker = () => __awaiter(void 0, void 0, void 0, function* () {
    if (dashboardWorkerRef == undefined) {
        const workerRef = new Worker(new URL("./dashboard.worker.ts", import.meta.url));
        dashboardWorkerRef = Comlink.wrap(workerRef);
    }
    if (window.Worker) {
        try {
            yield dashboardWorkerRef.setSessionDataImpl(JSON.stringify(getCompleteSessionData()));
            // const responseData = await dashboardWorkerRef.getMarketStatusImpl();
            // console.log(responseData);
        }
        catch (error) {
            console.error(error);
        }
        //     if (process.env.REACT_APP_ENV == "development") {
        //   } else {
        //   }
    }
});
